import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const submitRatePreview = createAsyncThunk(
  "ratePreview/submitFeedback",
  async (feedbackData, { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post("/api/user/newconstruction/rate", feedbackData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to submit feedback.");
    }
  }
);

const ratePreviewSlice = createSlice({
  name: "ratePreview",
  initialState: {
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitRatePreview.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(submitRatePreview.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(submitRatePreview.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default ratePreviewSlice.reducer;